import { GetAuditLogsRPCClientImpl } from "@pulse/pulse-rpcs/lib/audit-logs/getAuditLogsRPCClientImpl";
import { MOCK } from "@pulse/shared-components";
import { APIClient } from "@surya-digital/tedwig";
import { MockGetAuditLogsRPCClientImpl } from "./MockGetAuditLogsRPCClient";
import { GetAuditLogsRPC } from "@pulse/pulse-rpcs/lib/audit-logs/getAuditLogsRPC";

export const useGetAuditLogsRPCClient = (
  apiClient: APIClient,
): GetAuditLogsRPC => {
  if (MOCK.auditLogs) {
    return new MockGetAuditLogsRPCClientImpl();
  } else {
    return new GetAuditLogsRPCClientImpl(apiClient);
  }
};
